const LoadHistoryConstants = {
  GET_SUCCESS: 'LOADHISTORY_GET_SUCCESS',
  GETMORE_SUCCESS: 'LOADHISTORY_GETMORE_SUCCESS',
  GET_FAIL: 'LOADHISTORY_GET_FAIL',
  FETCH_STARTED: 'LOADHISTORY_FETCH_STARTED',
  FETCH_RANGE_STARTED: 'LOADHISTORY_FETCH_RANGE_STARTED',
  CLEAR_ALL: 'LOADHISTORY_CLEAR_ALL',
  SET_MAX_SAMPLES: 'LOADHISTORY_SET_MAX_SAMPLES'
};

export default LoadHistoryConstants;